"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
const UserServiceStub_1 = require("./UserServiceStub");
const UserServiceLive_1 = require("./UserServiceLive");
class UserService {
    static create(stub) {
        if (stub) {
            return new UserServiceStub_1.UserServiceStub();
        }
        return new UserServiceLive_1.UserServiceLive();
    }
}
exports.UserService = UserService;
//# sourceMappingURL=UserService.js.map